import React, { Component } from 'react';
import { drizzleConnect } from 'drizzle-react';

class AccountInfo extends Component {
  render() {
    const accounts = this.props.accounts;
    const accountKeys = Object.keys(accounts);
    const convertCurrencyFromWei = (num) => {
      const amount = (isNaN(num) ? 0 : Number(num));
      const factor = Math.pow(10, 18);
      return (amount / factor).toFixed(3);
    }
    const activeAccount = {
      key: accountKeys[0] || 'NA',
      balance: convertCurrencyFromWei(accounts[accountKeys[0]])
    }
    return (
      <div className="account-info">
        <span className="account-key">ACC: {activeAccount.key}</span>
        <span className="account-balance"> BAL: {activeAccount.balance} ETH</span>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return { accounts: state.accountBalances };
};

export default drizzleConnect(AccountInfo, mapStateToProps);


// WEBPACK FOOTER //
// ./src/components/AccountInfo.js